// DeleteItemModal.jsx
import React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import "./modal.css";
import { useDeleteItemMutation } from "../api/api";

const DeleteItemModal = ({
  modalOpen,
  toggleModal,
  itemType, // expects one of: "brands" | "colors" | "numbers" | "types" | "locations"
  tableData,
  setTableData,
  editItemData,
  setEditItemData,
  notificationComponentRef,
}) => {
  // map plural table type -> modal title + singular endpoint slug used by your API
  const map = {
    brands: { title: "Delete Brand", endpoint: "brand" },
    colors: { title: "Delete Color", endpoint: "color" },
    numbers: { title: "Delete Number", endpoint: "number" },
    types: { title: "Delete Type", endpoint: "type" },
    locations: { title: "Delete Location", endpoint: "location" },
  };

  const key = (itemType || "").toLowerCase();
  const meta = map[key] || { title: "Delete Item", endpoint: "" };

  const [deleteItem, { isLoading }] = useDeleteItemMutation();

  const handleSubmit = async () => {
    try {
      const deletedID = editItemData?.id;
      if (!deletedID || !meta.endpoint) {
        throw new Error("Missing item id or endpoint.");
      }

      // RTK Query mutation (your builder.mutation definition expects { endpoint, ...body })
      await deleteItem({ endpoint: meta.endpoint, id: deletedID }).unwrap();

      // Optional optimistic UI update for local table state
      if (Array.isArray(tableData) && typeof setTableData === "function") {
        setTableData(tableData.filter((row) => row.id !== deletedID));
      }

      // Reset/close
      setEditItemData?.({});
      toggleModal?.();

      notificationComponentRef?.current?.showNotification(
        `Item of ${key} with ID: ${deletedID} has been deleted successfully`,
        "success"
      );
    } catch (err) {
      const msg =
        err?.data?.message ||
        err?.error ||
        err?.message ||
        "Failed to delete item";
      notificationComponentRef?.current?.showNotification(msg, "danger");
      console.error("Delete error:", err);
    }
  };

  const focusFirstControl = () => {
    requestAnimationFrame(() => {
      const root = document.getElementById("cms-delete-item-modal");
      const el = root?.querySelector(
        "input:not([type='hidden']):not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled])"
      );
      el?.focus?.();
    });
  };

  return (
    <Modal
      id="cms-delete-item-modal"
      className="add-item-modal"
      isOpen={modalOpen}
      toggle={toggleModal}
      onOpened={focusFirstControl}
    >
      <ModalHeader toggle={toggleModal}>{meta.title}</ModalHeader>
      <ModalBody>
        <h4>Do you want to delete this {meta.endpoint}?</h4>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={toggleModal} disabled={isLoading}>
          Cancel
        </Button>
        <Button color="danger" onClick={handleSubmit} disabled={isLoading}>
          {isLoading ? "Deleting..." : "Delete"}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default DeleteItemModal;
